/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useContext, useEffect, useState } from 'react';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import StatCard from '../../components/dashboard/statCard/StatCard';
import DetailsCard from '../../components/dashboard/DetailsCard/DetailsCard';
import CustomDatePicker from '../../components/dashboard/customDatePicker/CustomDatePicker';
import { getCreatorDetails } from '../../services/dashboard.service';
import { formatCurrency } from '../../utils/global';
import LoaderSvg from '../../assets/images/loader.svg';
import styles from '../../styles/dashboard.module.css';
import { InboundContext } from '../../context/InboundContext';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Home() {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [dateRange, setDateRange] = useState<any>([]);

  const [selectedDays, setSelectedDays] = useState<number>(-1);
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const [creatorCommission, setCreatorCommission] = useState<any>(0);
  const { inboundData, isNonAffiliate, setIsNonAffiliate, homePageData, setHomePageData } = useContext(InboundContext);

  const fetchHomePageData = async () => {
    setIsLoading(true);
    let body = {};
    if (dateRange[0] && dateRange[1]) {
      body = {
        fromDate: dayjs.utc(dayjs(dateRange[0]).format('YYYY-MM-DDTHH:mm:ss')).format(),
        toDate: dayjs.utc(dayjs(dateRange[1]).format('YYYY-MM-DDTHH:mm:ss')).format(),
      };
    }
    const response = await getCreatorDetails(body);
    if (response.status) {
      setHomePageData(response.data);
      if (response?.data?.isNonAffiliate) {
        setCreatorCommission(0);
        setIsLoading(false);
        setIsNonAffiliate(true);
        return;
      }
      if (
        response.data.creatorCommission.type === 'percentage' &&
        (!response.data.creatorCommission.amount || !response?.data?.creatorCommission?.value)
      ) {
        const commission = `${response.data.creatorCommission.amount || response?.data?.creatorCommission?.value}%`;
        setCreatorCommission(commission);
      } else if (response.data.creatorCommission.type === 'fixed_amount') {
        const commission = `${response?.data?.formattedCurrencyLogo || '$'}${
          response.data.creatorCommission.amount || response?.data?.creatorCommission?.value
        }`;
        setCreatorCommission(commission);
      } else if (response.data.defaultCommissionValue > 0) {
        if (response.data.defaultCommissionType === 'percentage') {
          const commission = `${response.data.defaultCommissionValue}%`;
          setCreatorCommission(commission);
        } else {
          const commission = `${response?.data?.formattedCurrencyLogo || '$'}${response.data.defaultCommissionValue}`;
          setCreatorCommission(commission);
        }
      } else {
        setCreatorCommission(0);
      }
    }
    setIsLoading(false);
  };

  // const formatRoas = () => {
  //   return homePageData.creatorPerformance?.commission === 0
  //     ? '0x'
  //     : `${(homePageData?.creatorPerformance?.revenue / homePageData?.creatorPerformance?.commission)?.toFixed(2)}x`;
  // };

  useEffect(() => {
    document.title = `${inboundData?.landingPage?.brandName} - Creator Dashboard`;
  }, []);
  useEffect(() => {
    if ((!dateRange[0] && !dateRange[1]) || (dateRange[0] && dateRange[1])) {
      fetchHomePageData();
    }
  }, [dateRange]);

  return (
    <DashboardWrapper
      heading="Dashboard"
      rightHeaderComponent={
        !isNonAffiliate && (
          <div className={styles.headerDatePicker}>
            <CustomDatePicker
              selectedDays={selectedDays}
              showDatePicker={showDatePicker}
              dateRange={dateRange}
              setDateRange={setDateRange}
              setSelectedDays={setSelectedDays}
              setShowDatePicker={setShowDatePicker}
            />
          </div>
        )
      }
    >
      {isLoading && (
        <div className={styles.loaderDiv}>
          <img src={LoaderSvg} alt="loader" width={100} />
        </div>
      )}

      {!isLoading && homePageData && (
        <>
          {!isNonAffiliate && (
            <>
              <div className={styles.mobileDateRangeDiv}>
                <CustomDatePicker
                  selectedDays={selectedDays}
                  showDatePicker={showDatePicker}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  setSelectedDays={setSelectedDays}
                  setShowDatePicker={setShowDatePicker}
                />
              </div>
              <div className={styles.statsContainer}>
                <StatCard title="Visitors" value={`${homePageData?.creatorPerformance?.referrals}`} icon="👀" />
                <StatCard
                  title="Revenue"
                  value={`${formatCurrency(homePageData?.creatorPerformance?.revenue, homePageData?.defaultCurrency)}`}
                  icon="💰"
                />
                <StatCard title="Orders" value={`${homePageData?.creatorPerformance?.num_orders}`} icon="🛍️" />
                {/* <StatCard title="ROAS" value={formatRoas()} icon="📈" /> */}
                <StatCard
                  title="Commission"
                  value={`${formatCurrency(
                    homePageData?.creatorPerformance?.commission,
                    homePageData?.defaultCurrency
                  )}`}
                  icon="📈"
                />
              </div>
            </>
          )}

          <DetailsCard
            fullName={homePageData?.creatorDetails?.name}
            trackingLink={homePageData.refferalLink} // first link
            refCode={homePageData.refCode}
            trackingLinks={homePageData?.affiliateReferralLinks} // other links
            couponCode={homePageData.coupons}
            commission={creatorCommission}
            email={homePageData?.creatorDetails?.email}
            address={homePageData?.creatorDetails?.addresses}
            fetchHomePageData={fetchHomePageData}
            profileId={homePageData?.creatorDetails?._id}
            paypalEmail={homePageData?.creatorDetails?.paypalEmail}
            affiliateId={homePageData?.affiliateId}
            dynamicDiscountEnabled={homePageData?.dynamicDiscountEnabled}
            userName={homePageData?.creatorDetails?.user_name}
            platform={homePageData?.creatorDetails?.platform}
            isNonAffiliate={isNonAffiliate}
            totalSubmissions={homePageData?.totalSubmissions}
            totalPayments={homePageData?.totalPayments}
            defaultCurrency={homePageData?.defaultCurrency}
          />
        </>
      )}
    </DashboardWrapper>
  );
}
